export const SKINS = {
  standard: 'standard',
  standardFilled: 'standardFilled',
  light: 'light',
  lightFilled: 'lightFilled',
  dark: 'dark',
  transparent: 'transparent',
} as const;

export const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const testDataHooks = {
  customIcon: 'custom-icon',
};
